// Image sizes dictionary per set type
const imageSizes = {
  setType2: {
    0: [
      { actual: 175, intrinsic: 300 },
      { actual: 215, intrinsic: 350 },
      { actual: 315, intrinsic: 450 },
      { actual: 375, intrinsic: 550 }
    ],
    1: [
      { actual: 215, intrinsic: 350 },
      { actual: 270, intrinsic: 400 },
      { actual: 415, intrinsic: 600 },
      { actual: 580, intrinsic: 840 },
      { actual: 695, intrinsic: 980 }
    ],
    2: [
      { actual: 175, intrinsic: 300 },
      { actual: 215, intrinsic: 350 },
      { actual: 315, intrinsic: 450 },
      { actual: 375, intrinsic: 550 }
    ],
    3: [
      { actual: 215, intrinsic: 350 },
      { actual: 270, intrinsic: 400 },
      { actual: 360, intrinsic: 550 },
      { actual: 450, intrinsic: 660 }
    ],
    4: [
      { actual: 175, intrinsic: 300 },
      { actual: 215, intrinsic: 350 },
      { actual: 315, intrinsic: 450 },
      { actual: 375, intrinsic: 550 }
    ],
    5: [
      { actual: 175, intrinsic: 300 },
      { actual: 215, intrinsic: 350 },
      { actual: 315, intrinsic: 450 },
      { actual: 375, intrinsic: 550 }
    ],
    6: [
      { actual: 215, intrinsic: 350 },
      { actual: 290, intrinsic: 420 },
      { actual: 360, intrinsic: 550 },
      { actual: 505, intrinsic: 720 },
      { actual: 505, intrinsic: 850 }
    ]
  },
  setType1: {
    0: [
      { actual: 215, intrinsic: 350 },
      { actual: 290, intrinsic: 420 },
      { actual: 360, intrinsic: 550 },
      { actual: 500, intrinsic: 700 },
      { actual: 505, intrinsic: 850 }
    ],
    1: [
      { actual: 200, intrinsic: 300 },
      { actual: 215, intrinsic: 350 },
      { actual: 295, intrinsic: 420 },
      { actual: 355, intrinsic: 500 }
    ],
    2: [
      { actual: 230, intrinsic: 350 },
      { actual: 215, intrinsic: 350 },
      { actual: 315, intrinsic: 450 },
      { actual: 375, intrinsic: 550 }
    ],
    3: [
      { actual: 215, intrinsic: 350 },
      { actual: 270, intrinsic: 400 },
      { actual: 360, intrinsic: 550 },
      { actual: 440, intrinsic: 630 }
    ],
    4: [
      { actual: 230, intrinsic: 350 },
      { actual: 290, intrinsic: 420 },
      { actual: 410, intrinsic: 580 },
      { actual: 490, intrinsic: 700 }
    ],
    5: [
      { actual: 215, intrinsic: 350 },
      { actual: 270, intrinsic: 400 },
      { actual: 390, intrinsic: 550 },
      { actual: 470, intrinsic: 660 }
    ]
  }
};

export default imageSizes;
